<script setup>
defineProps({
  template: {
    type: Object,
    required: true,
  },
});

defineEmits(['click']);

const iconMap = {
  'blog-post': '📝',
  'code-refactor': '⚙️',
  'email-polisher': '✉️',
  'creative-storyteller': '🎭',
  'headline-generator': '⭕',
  'data-summarizer': '📊',
  default: '💡',
};

const getIcon = iconName => {
  return iconMap[iconName] || iconMap.default;
};
</script>

<template>
  <button
    class="flex flex-col gap-2 p-4 text-left transition-all duration-200 bg-white border rounded-xl border-slate-200 dark:border-slate-700 dark:bg-slate-800 hover:shadow-md hover:border-woot-500 dark:hover:border-woot-400 cursor-pointer group"
    @click="$emit('click')"
  >
    <div class="flex items-center gap-2">
      <span class="text-lg">{{ getIcon(template.icon) }}</span>
      <h4
        class="text-sm font-semibold text-slate-800 dark:text-slate-100 group-hover:text-woot-500 dark:group-hover:text-woot-400"
      >
        {{ template.name }}
      </h4>
    </div>
    <p
      class="text-xs leading-relaxed text-slate-500 dark:text-slate-400 line-clamp-3"
    >
      {{ template.description }}
    </p>
  </button>
</template>
